import { Link } from "react-router-dom";
import {
  Phone,
  Mail,
  MapPin,
  MessageCircle,
} from "lucide-react";
import { company, categories } from "../data/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1E1E1E] text-white/80 relative overflow-hidden"
    >
      {/* gold hairline top */}
      <div className="h-[1px] bg-gradient-to-r from-transparent via-[#B8860B] to-transparent" />

      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-12 gap-10">
        {/* Brand + about */}
        <div className="col-span-2 lg:col-span-4">
          <Link to="/" className="inline-block">
            <img src="/serapark-logo-white.png" alt="SeramikPark" className="h-12 md:h-16 w-auto" />
          </Link>
          <p className="mt-5 text-[14px] leading-relaxed text-white/60 max-w-sm">
            Premium seramik, porselen ve yapı malzemelerinde Türkiye'nin
            referans showroom deneyimi. Şanlıurfa merkezli, ülke geneli
            hizmet.
          </p>
        </div>

        {/* Nav */}
        <div className="lg:col-span-2">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#B8860B] mb-5">
            Kurumsal
          </div>
          <ul className="space-y-3 text-[13px]">
            <li><Link to="/kurumsal" className="hover:text-white">Hakkımızda</Link></li>
            <li><Link to="/kurumsal#misyon" className="hover:text-white">Misyon</Link></li>
            <li><Link to="/kurumsal#vizyon" className="hover:text-white">Vizyon</Link></li>
            <li><Link to="/kurumsal#kalite" className="hover:text-white">Kalite Politikası</Link></li>
            <li><Link to="/projeler" className="hover:text-white">Referanslar</Link></li>
          </ul>
        </div>
        <div className="lg:col-span-2">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#B8860B] mb-5">
            Ürünler
          </div>
          <ul className="space-y-3 text-[13px]">
            {categories.slice(0, 6).map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/urunler?kategori=${c.slug}`}
                  className="hover:text-white"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Contact */}
        <div className="col-span-2 lg:col-span-4">
          <div className="text-[10px] tracking-[0.3em] uppercase text-[#B8860B] mb-5">
            İletişim
          </div>
          <ul className="space-y-4 text-[13px]">
            <li className="flex gap-3">
              <MapPin size={16} className="text-[#B8860B] shrink-0 mt-0.5" />
              <span className="text-white/70 leading-relaxed">{company.address}</span>
            </li>
            <li className="flex gap-3">
              <Phone size={16} className="text-[#B8860B] shrink-0 mt-0.5" />
              <a href={`tel:${company.phoneRaw}`} className="hover:text-white">
                {company.phone}
              </a>
            </li>
            <li className="flex gap-3">
              <MessageCircle size={16} className="text-[#B8860B] shrink-0 mt-0.5" />
              <a
                href={company.whatsapp}
                target="_blank"
                rel="noreferrer"
                className="hover:text-white"
              >
                WhatsApp: {company.phone}
              </a>
            </li>
            <li className="flex gap-3">
              <Mail size={16} className="text-[#B8860B] shrink-0 mt-0.5" />
              <a href={`mailto:${company.email}`} className="hover:text-white">
                {company.email}
              </a>
            </li>
          </ul>

          <div className="mt-6 pt-6 border-t border-white/10 space-y-1 text-[12px] text-white/50">
            {company.hours.map((h) => (
              <div key={h.day} className="flex justify-between max-w-xs">
                <span>{h.day}</span>
                <span className="text-white/70">{h.time}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between gap-4 text-[11px] text-white/40">
          <div>
            © {new Date().getFullYear()} SeraPark. Tüm hakları saklıdır.
          </div>
          <div className="flex gap-6">
            <Link to="/kvkk" className="hover:text-white/80">KVKK</Link>
            <Link to="/gizlilik" className="hover:text-white/80">Gizlilik Politikası</Link>
            <Link to="/cerez" className="hover:text-white/80">Çerez Politikası</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
